import React from 'react';
import { Section } from './Section';
import { motion } from 'framer-motion';
import { Bell } from 'lucide-react';
export function Newsletter() {
  return <Section id="newsletter" title="The Networking Salon Newsletter" className="bg-gray-50" data-id="element-117">
      <div className="max-w-4xl mx-auto" data-id="element-118">
        <motion.div className="mb-8 text-center" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-119">
          <div className="flex justify-center mb-4" data-id="element-120">
            <Bell size={32} className="text-gray-700" data-id="element-121" />
          </div>
          <p className="text-lg text-gray-700 mb-6" data-id="element-122">
            Stay updated with the latest insights on networking, learning
            experiences, and professional growth. Subscribe to my LinkedIn
            Newsletter for weekly tips and strategies.
          </p>
          <a href="https://www.linkedin.com/newsletters/the-networking-salon-%25F0%259F%2593%25A3-6970049734086377472/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-6 py-3 rounded-full text-sm font-medium transition-all duration-300 shadow-sm bg-gray-900 text-white hover:bg-gray-800" data-id="element-123">
            Subscribe to Newsletter
          </a>
        </motion.div>
        <div className="bg-white rounded-xl shadow-md overflow-hidden" data-id="element-124">
          <div className="relative pb-[56.25%] h-0" data-id="element-125">
            <iframe src="https://www.linkedin.com/embed/feed/update/urn:li:share:7146874839429988352" height="100%" width="100%" frameBorder="0" allowFullScreen title="LinkedIn Newsletter" className="absolute top-0 left-0 w-full h-full" data-id="element-126"></iframe>
          </div>
        </div>
      </div>
    </Section>;
}